function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider, createTheme, createGenerateClassName, jssPreset, StylesProvider } from '@material-ui/core/styles';
import { create as createJss } from 'jss';
import aulaTheme from '../../themes/default';
import { jsx as ___EmotionJSX } from "@emotion/core";
const generateClassName = createGenerateClassName({
  productionPrefix: 'aulaui-mui'
});
const JssInstance = createJss(_objectSpread(_objectSpread({}, jssPreset()), {}, {
  insertionPoint: 'custom-insertion-point'
})); // Setup the basic MUI theme for Aula

const MUI_AULA_THEME = {
  typography: {
    fontFamily: aulaTheme.font.family.workSans,
    fontWeightRegular: aulaTheme.font.weight.regular,
    fontWeightMedium: aulaTheme.font.weight.medium,
    fontWeightBold: aulaTheme.font.weight.bold,
    useNextVariants: true
  },
  palette: {
    primary: {
      light: aulaTheme.color.designSystem.purple60,
      main: aulaTheme.color.designSystem.purple70,
      dark: aulaTheme.color.designSystem.purple80,
      contrastText: aulaTheme.color.black
    },
    secondary: {
      light: aulaTheme.color.white,
      main: aulaTheme.color.grayLight,
      dark: aulaTheme.color.gray,
      contrastText: aulaTheme.color.black
    },
    text: {
      hint: aulaTheme.color.grey11
    }
  }
};
const muiAulaTheme = createTheme(MUI_AULA_THEME);

const MuiProvider = ({
  theme,
  children
}) => ___EmotionJSX(StylesProvider, {
  jss: JssInstance,
  generateClassName: generateClassName
}, ___EmotionJSX(MuiThemeProvider, {
  theme: theme || muiAulaTheme
}, children));

MuiProvider.defaultProps = {
  theme: null
};
MuiProvider.propTypes = {
  theme: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  children: PropTypes.node.isRequired
};
export default MuiProvider;
//# sourceMappingURL=Mui.js.map